<ng-persian-datepicker (dateOnSelect)="onDateChange($event)" uiHideAfterSelectDate="false">
    <input #dateInput class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-60 rounded text-sm w-full" 
        [formControl]="dateValue" type="text" />
    <span
        class="absolute end-2.5 bottom-2.5 bg-blue-700 font-medium rounded-lg text-sm p-1 left-0">
        <img src="../../../../assets/img/icon/calendar.svg" class="w-8 pt-1" alt="">
    </span>
</ng-persian-datepicker>
  
  
  <!-- [uiTheme]="customTheme" -->